var _rect, _path, _circle, _circle2, _circle3, _rect2, _line, _line2, _line3, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 418,
    viewBox: "0 0 501 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 501,
    height: 417.822,
    rx: 32,
    fill: "#9BEAC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31C0 13.8792 13.8792 0 31 0H470C487.121 0 501 13.8792 501 31V86H0V31Z",
    fill: "#B2F8DB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 43.5,
    r: 8.5,
    fill: "#5DC89B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 43.5,
    r: 8.5,
    fill: "#5DC89B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 43.5,
    r: 8.5,
    fill: "#5DC89B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 123,
    width: 416,
    height: 256,
    rx: 22,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 159,
    x2: 368,
    y2: 159,
    stroke: "#5DC89B",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 192,
    x2: 269,
    y2: 192,
    stroke: "#5DC89B",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 226,
    x2: 168,
    y2: 226,
    stroke: "#5DC89B",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 274C75 269.582 78.5817 266 83 266H123C127.418 266 131 269.582 131 274V363H75V274Z",
    fill: "#9BEAC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 307C150 302.582 153.582 299 158 299H199C203.418 299 207 302.582 207 307V363H150V307Z",
    fill: "#9BEAC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301 307C301 302.582 304.582 299 309 299H350C354.418 299 358 302.582 358 307V363H301V307Z",
    fill: "#9BEAC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377 307C377 302.582 380.582 299 385 299H425C429.418 299 433 302.582 433 307V363H377V307Z",
    fill: "#9BEAC9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226 332C226 327.582 229.582 324 234 324H274C278.418 324 282 327.582 282 332V363H226V332Z",
    fill: "#9BEAC9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.3946c94b75f99baa6dac1c14a2be9681.svg";
export { ForwardRef as ReactComponent };